import { getDuration } from './DateUtils25.js';
import { getNow } from './DateUtils3.js';

const getDurationFromNow = (tzDate) => {
    return getDuration(tzDate, getNow());
};

export { getDurationFromNow };
